module.exports = __webpack_public_path__ + "img/创建合约模板.083d2b01.jpg";